"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_modal_1 = __importDefault(require("react-modal"));
var CalculatorContextInterface_1 = require("../components/calculator/CalculatorContextInterface");
var react_i18next_1 = require("react-i18next");
var axios_1 = __importDefault(require("axios"));
var react_hook_form_1 = require("react-hook-form");
var customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        minWidth: '50%',
        padding: '24px',
        borderRadius: '8px',
        border: '1px solid rgba(224, 224, 224, 1)',
        boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.16)'
    },
};
//Modal.setAppElement('#open-modal-custom-order');
var CustomOrderView = function () {
    var _a = (0, react_hook_form_1.useForm)(), handleSubmit = _a.handleSubmit, register = _a.register, reset = _a.reset, setValue = _a.setValue, errors = _a.formState.errors;
    var _b = (0, react_1.useState)(false), isShowPurchase = _b[0], setIsShowPurchase = _b[1];
    var game = (0, CalculatorContextInterface_1.useCalculatorContext)().game;
    var _c = (0, react_i18next_1.useTranslation)(), t = _c.t, i18n = _c.i18n;
    var _d = (0, react_1.useState)([]), contactList = _d[0], setContatList = _d[1];
    var _e = (0, react_1.useState)(0), orderId = _e[0], setOrderId = _e[1];
    var _f = (0, react_1.useState)(false), isDisabled = _f[0], setIsDisabled = _f[1];
    function handleClick() {
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?custom-order';
        window.history.pushState({ path: newurl }, '', newurl);
        setIsShowPurchase(function (prev) { return !prev; });
    }
    (0, react_1.useEffect)(function () {
        var searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('custom-order')) {
            setIsShowPurchase(true);
        }
        axios_1.default.get("/app/order/contact-list")
            .then(function (response) {
            if (response.status == 200) {
                setContatList(response.data);
            }
        }).catch(function (error) {
            console.log("error", error);
        });
    }, []);
    var onSubmit = function (data) {
        if (game) {
            data.game_id = game.id;
        }
        setIsDisabled(true);
        axios_1.default.post("/app/order/custom", data)
            .then(function (response) {
            if (response.status == 200) {
                setOrderId(parseInt(response.data.id));
                reset();
                //setContatList(response.data);
            }
        }).catch(function (error) {
            console.log("error", error);
        }).finally(function () {
            setIsDisabled(false);
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { onClick: handleClick, className: "__button" }, "\u0418\u043D\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043B\u044C\u043D\u044B\u0439 \u0437\u0430\u043A\u0430\u0437"),
        react_1.default.createElement(react_modal_1.default, { appElement: document.getElementById('open-modal-custom-order'), isOpen: isShowPurchase, style: customStyles },
            react_1.default.createElement("div", { className: "purchase-wrap-content", style: { width: '100%', minHeight: "fit-content" } },
                react_1.default.createElement("div", { className: "__wrap-caption" },
                    react_1.default.createElement("span", { className: "__caption" }, t("page.game.custom_order.caption")),
                    react_1.default.createElement("img", { onClick: function () { setIsShowPurchase(false); }, className: "close-modal", src: "/images/app/close.svg" })),
                react_1.default.createElement("div", { className: "__wrap-content " },
                    react_1.default.createElement("div", { className: "" },
                        react_1.default.createElement("div", { className: "__request-text" }, t("page.game.custom_order.text")),
                        orderId > 0
                            ?
                                react_1.default.createElement("div", { className: "__request-text-success" }, t("page.game.custom_order.text-success"))
                            : "",
                        react_1.default.createElement("form", { onSubmit: handleSubmit(onSubmit), className: "custom-order-modal" },
                            react_1.default.createElement("input", __assign({}, register("game_id"), { type: "hidden", value: game === null || game === void 0 ? void 0 : game.id })),
                            react_1.default.createElement("div", { className: "wrap-input" },
                                react_1.default.createElement("textarea", __assign({ className: errors.order_text ? "__has-error" : "" }, register("order_text", {
                                    validate: {
                                        positive: function (v) { return v.trim().length > 0; },
                                    },
                                }), { placeholder: t("page.game.custom_order.request_text"), rows: 5 }))),
                            react_1.default.createElement("div", { className: "wrap-input" },
                                react_1.default.createElement("label", null, t("page.game.custom_order.contact")),
                                react_1.default.createElement("select", __assign({ className: errors.contact ? "__has-error" : "" }, register("contact", {
                                    validate: {
                                        positive: function (v) { return v.trim().length > 0; },
                                    },
                                })),
                                    react_1.default.createElement("option", { value: "" }, t("page.game.custom_order.select_contact")),
                                    contactList.map(function (item, index) {
                                        return react_1.default.createElement("option", { value: item, key: index }, item);
                                    }))),
                            react_1.default.createElement("div", { className: "wrap-input" },
                                react_1.default.createElement("label", null, t("page.game.custom_order.contact_value")),
                                react_1.default.createElement("input", __assign({ className: errors.contact_value ? "__has-error" : "" }, register("contact_value", {
                                    validate: {
                                        positive: function (v) { return v.trim().length > 0; },
                                    },
                                }), { placeholder: t("page.game.custom_order.contact_value") }))),
                            react_1.default.createElement("div", { className: "wrap-input" },
                                react_1.default.createElement("button", { disabled: isDisabled, type: "submit", className: "" }, t("page.game.custom_order.submit"))))),
                    react_1.default.createElement("div", { className: "__right-side", style: { justifyContent: "center", padding: "0" } },
                        react_1.default.createElement("div", { className: "__caption" }, t("page.game.custom_order.caption-side")),
                        react_1.default.createElement("img", { style: { marginTop: "40px" }, src: "/images/web/icons8_check_all.png" })))))));
};
exports.default = CustomOrderView;
